import AdminNavigation from '@routes/components/AdminNavigation';
import React from 'react';

const AdminNavigationContainer = () => {
  return <AdminNavigation />;
};

export default AdminNavigationContainer;
